var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FileUpload',{attrs:{"default-file-list":_vm.out_value,"module":_vm.fileModule,"multiple":_vm.hasMultiple,"placeholder":_vm.options.placeholder,"doc-scan":_vm.options.scan,"delete-old-files":!_vm.hasMultiple},on:{"change":_vm.updateUploadField}})
}
var staticRenderFns = []

export { render, staticRenderFns }